import script from "./CustomToast.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomToast.vue?vue&type=script&setup=true&lang=ts"

import "./CustomToast.vue?vue&type=style&index=0&id=302540fb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-302540fb"]])

export default __exports__